import "react";
import { ColorSquare, Tag, TagGroup } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Tags/shared/Tags.tsx
var Tags = ({ onClick, subtle = false, tags, ...props }) => {
	const sortedTags = tags?.sort(function(a, b) {
		return (b?.level ?? 0) - (a?.level ?? 0);
	});
	if (Array.isArray(sortedTags)) {
		if (subtle) return /* @__PURE__ */ jsx(TagGroup, {
			...props,
			children: sortedTags.map((tag) => {
				return /* @__PURE__ */ jsxs("div", {
					className: classnames("bg-surface-strong px-xs text-color-neutral rounded text-sm", { "cursor-pointer": !!onClick }),
					onClick: () => onClick?.(tag),
					children: [
						tag.color && /* @__PURE__ */ jsx("span", {
							className: "mr-xxs",
							children: /* @__PURE__ */ jsx(ColorSquare, { color: tag.color })
						}),
						" ",
						tag.title
					]
				}, tag.id || tag.title);
			})
		});
		return /* @__PURE__ */ jsx(TagGroup, {
			...props,
			children: sortedTags.map((tag) => /* @__PURE__ */ jsx(Tag, {
				backgroundColor: tag.color,
				value: tag.title
			}, tag.id || tag.title))
		});
	}
	return null;
};
//#endregion
export { Tags };

//# sourceMappingURL=Tags.js.map